"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _getSources = require("@studio/sources/getSources");
var _VideoQualitySettings = require("@studio/constants/VideoQualitySettings");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _Sources = require("@studio/constants/Sources");
var _ScreenShare = require("../../utils/ScreenShare");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var LOG = new _StudioLogger.StudioLogger('handleAgoraOnStagePriority');

/**
 * Handles Agora OnStage Priority by configuring video priorities
 * and muting the local screen share audio while it is off stage
 *
 * @param {Object} options - Options for handling on-stage priority
 * @param {Object} options.agoraClient - The Agora client instance
 * @param {string} options.attendeeId - The attendee ID of the local user
 * @param {Object} options.payload - The current program state
 * @returns {Function} Redux thunk action
 */
function handleAgoraOnStagePriority() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    agoraClient = _ref.agoraClient,
    attendeeId = _ref.attendeeId,
    payload = _ref.payload;
  return function (dispatch, getState) {
    var action = {
      type: _types.SET_AGORA_ONSTAGE_PRIORITY,
      request: function () {
        var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var _stateProgram$program;
          var _getState, _getState$meeting, _getState$meeting$cli, client, stateAttendeeId, meetingId, screenShare, _getState$program, _stateProgram, sources, cameraSources, stateProgram, program, localAttendeeId, isAgoraClientConnected, cameraSourcesInProgram, remoteAttendeeIds, attendeeStagePriority, _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                _getState = getState(), _getState$meeting = _getState.meeting, _getState$meeting$cli = _getState$meeting.client, client = _getState$meeting$cli === void 0 ? agoraClient : _getState$meeting$cli, stateAttendeeId = _getState$meeting.attendeeId, meetingId = _getState$meeting.meetingId, screenShare = _getState$meeting.screenShare, _getState$program = _getState.program, _stateProgram = _getState$program === void 0 ? {} : _getState$program, sources = _getState.broadcastSources.sources;
                cameraSources = (0, _getSources.getCameraSources)(sources);
                stateProgram = (_stateProgram$program = _stateProgram === null || _stateProgram === void 0 ? void 0 : _stateProgram.program) !== null && _stateProgram$program !== void 0 ? _stateProgram$program : _stateProgram;
                program = payload || stateProgram;
                localAttendeeId = attendeeId || stateAttendeeId;
                isAgoraClientConnected = (client === null || client === void 0 ? void 0 : client.connectionState) === 'CONNECTED';
                if (!(program === null)) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                if (!screenShare.audioTrack) {
                  _context2.n = 2;
                  break;
                }
                _context2.n = 2;
                return (0, _ScreenShare.syncScreenShareAudioWithStage)({
                  audioTrack: screenShare.audioTrack,
                  screenShareAttendeeId: screenShare.client.uid,
                  program: program
                });
              case 2:
                if (isAgoraClientConnected) {
                  _context2.n = 3;
                  break;
                }
                return _context2.a(2);
              case 3:
                // Get the camera sources that are currently in the program.
                cameraSourcesInProgram = Object.values((0, _getSources.getCameraPresenterSources)(program.layers)).filter(function (src) {
                  return (src === null || src === void 0 ? void 0 : src.value) !== _Sources.UNASSIGNED;
                }).map(function (src) {
                  return src.value;
                });
                remoteAttendeeIds = cameraSources.filter(function (src) {
                  return (src === null || src === void 0 ? void 0 : src.value) !== localAttendeeId;
                }).map(function (src) {
                  return src.value;
                });
                _context2.p = 4;
                _context2.n = 5;
                return Promise.all(remoteAttendeeIds.map(/*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
                    var isAttendeeOnStage;
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          isAttendeeOnStage = cameraSourcesInProgram.includes(id);
                          _context.n = 1;
                          return client.setRemoteVideoStreamType(id, isAttendeeOnStage ? _VideoQualitySettings.HIGH_PRIORITY_STREAM : _VideoQualitySettings.LOW_PRIORITY_STREAM);
                        case 1:
                          return _context.a(2, {
                            attendeeId: id,
                            streamType: isAttendeeOnStage ? 'high' : 'low'
                          });
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));
              case 5:
                attendeeStagePriority = _context2.v;
                LOG.info("Agora video priority updated for attendee: ".concat(localAttendeeId, " in meeting: ").concat(meetingId), {
                  attendeeStagePriority: attendeeStagePriority
                });
                return _context2.a(2, {
                  attendeeStagePriority: attendeeStagePriority
                });
              case 6:
                _context2.p = 6;
                _t = _context2.v;
                LOG.error("Agora video priority update failed for attendee: ".concat(localAttendeeId, " in meeting: ").concat(meetingId), {
                  errorMessage: _t.message,
                  remoteAttendeeIds: remoteAttendeeIds
                });
              case 7:
                return _context2.a(2);
            }
          }, _callee2, null, [[4, 6]]);
        }));
        function request() {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    };
    dispatch(action);
  };
}
var _default = exports["default"] = handleAgoraOnStagePriority;